import Adjust from '@adjustcom/adjust-web-sdk'

const ADJUST_APP_TOKEN = 'ye8jrvebj6dc'

function getExternalDeviceId() {
  try {
    return localStorage.getItem('voox_eid')
  } catch (e) {
    return null
  }
}

export function initAdjust() {
  if (typeof window !== 'undefined') {
    window.__adjustInitCalled = true
  }
  try {
    Adjust.initSdk({
      appToken: ADJUST_APP_TOKEN,
      environment: 'production',
      externalDeviceId: getExternalDeviceId(),
    })
    if (typeof window !== 'undefined') {
      window.__adjustInitStatus = 'ok'
    }
    console.log('[Adjust] initSdk ok')
  } catch (e) {
    if (typeof window !== 'undefined') {
      window.__adjustInitStatus = 'failed: ' + e.message
    }
    console.error('[Adjust] initSdk failed:', e)
  }
}
